import { api } from "..";
const endpoint = "/api/estimates";

export const getQuotationList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getQuotationById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createQuotation = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const createQuotationHeader = async (data) => {
  return await api.post(`${endpoint}/header`, data);
};

export const updateQuotation = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteQuotation = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const updateQuotationStatus = async (id, data) => {
  return await api.put(`${endpoint}/${id}/status`, data);
};

export const computeEstimatesList = async (id, quantities) => {
  return await api.post(`${endpoint}/${id}/compute-list`, quantities);
}; 